import { Paper, Skeleton, Stack, Box } from '@mui/material';

const PackageLoader = () => {
  return [0, 1, 3].map((idx: number) => (
    <Paper
      key={idx}
      elevation={0}
      sx={{
        p: { xs: 1.5, sm: 2 },
        mb: 2,
        border: '1px solid #eaeaea',
        borderRadius: 2
      }}
    >
      <Box
        display='flex'
        flexDirection={{ xs: 'column', sm: 'row' }}
        justifyContent='space-between'
        alignItems={{ xs: 'flex-start', sm: 'center' }}
        gap={2}
      >
        {/* LEFT SIDE */}
        <Box display='flex' flexDirection={{ xs: 'column', sm: 'row' }} gap={1} flexWrap='wrap' width='100%'>
          <Stack direction='row' spacing={1} alignItems='center'>
            <Skeleton variant='text' width={120} height={24} />
            <Skeleton variant='circular' width={16} height={16} />
            <Skeleton variant='rounded' width={60} height={24} sx={{ borderRadius: 6 }} />
          </Stack>
          <Stack direction='row' spacing={1} alignItems='center'>
            <Skeleton variant='text' width={140} height={20} />

            <Skeleton variant='circular' width={16} height={16} />

            <Skeleton variant='text' width={20} height={20} />
          </Stack>
        </Box>
        <Stack direction='row' spacing={1}>
          <Skeleton variant='circular' width={32} height={32} />
          <Skeleton variant='circular' width={32} height={32} />
          <Skeleton variant='circular' width={32} height={32} />
        </Stack>
      </Box>
    </Paper>
  ));
};

export default PackageLoader;
